import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthStateService } from '../states/auth.state.service';
import { environment } from 'src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const authStateService = inject(AuthStateService);
  const authToken = authStateService.accessToken();


  let headers: { [name : string] : string | string []} = {};

  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  headers['X-Platform-Type'] = environment.catalogPlatformType;

  const authReq = req.clone({ setHeaders: headers });

  return next(authReq);
};
